import Hero from "./components/Hero";
import SubscribeForm from "./components/SubscribeForm";
import "./App.css";
import { Toaster } from "react-hot-toast";
function App() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4">
      <Toaster />
      <Hero />
      <SubscribeForm />
    </main>
  );
}

export default App;